import React from "react";
import moment from "moment";

class ReporteVentasCompras extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            telefonoSoporte: "+51933386658",
        };
    }

    redirigirWhatsApp = () => {
        const { telefonoSoporte } = this.state;
        const mensaje = encodeURIComponent("Hola, necesito información sobre el reporte SIRE de ventas y compras.");
        const url = `https://wa.me/${telefonoSoporte}?text=${mensaje}`;
        window.open(url, '_blank');
    }

    render() {
        return (
            <>
                <div className="text-center py-5">
                    <div className="mb-4">
                        <h4 className="text-muted mb-3">Reporte de Ventas y Compras</h4>
                        <p className="text-muted mb-4">
                            Actualmente no tienes acceso para este módulo. Para más información, 
                            comunícate con nuestro equipo de soporte.
                        </p>
                    </div>
                    
                    <div className="card border-0 shadow-sm mx-auto" style={{ maxWidth: '400px' }}>
                        <div className="card-body">
                            <h5 className="card-title mb-3" style={{ color: '#01A59C' }}>
                                <i className="fas fa-headset me-2"></i>
                                Soporte Técnico
                            </h5>
                            <p className="card-text mb-4">
                                ¿Necesitas ayuda con los reportes o tienes preguntas específicas?
                            </p>
                            
                            <button 
                                className="btn btn-success btn-lg w-100"
                                onClick={this.redirigirWhatsApp}
                                style={{
                                    backgroundColor: '#01A59C',
                                    borderColor: '#01A59C',
                                    borderRadius: '25px'
                                }}
                            >
                                <i className="fab fa-whatsapp me-2"></i>
                                Contactar por WhatsApp
                            </button>
                            
                            <div className="mt-3 text-muted small">
                                <i className="fas fa-clock me-1"></i>
                                Horario de atención: Lunes a Viernes 8:30 AM - 7:30 PM
                            </div>
                        </div>
                    </div>
                    
                </div>            
            </>
        )
    }
}

export default ReporteVentasCompras;